import React from "react";
import ApplicationC from "./components/ApplicationContainer";


class App extends React.Component {
    render() {
        return (<ApplicationC/>);
    }
}


export default App;
